import { getDomainConfig, getLocale, LINKS, visitDashboard } from '@raisin/cp-utils';
import { getSavingglobalUrl } from '../utils';
export const HAS_FIXED_DEPOSIT_ACCOUNT = 'HAS_FIXED_DEPOSIT_ACCOUNT';
export const HAS_FLEX_DEPOSIT_ACCOUNT = 'HAS_FLEX_DEPOSIT_ACCOUNT';
export const HAS_INVESTMENT_PRODUCT_ACCOUNT = 'HAS_INVESTMENT_PRODUCT_ACCOUNT';
export const HAS_NOTICE_DEPOSIT_ACCOUNT = 'HAS_NOTICE_DEPOSIT_ACCOUNT';
export const HAS_OVERNIGHT_DEPOSIT_ACCOUNT = 'HAS_OVERNIGHT_DEPOSIT_ACCOUNT';
export const getIrlMenus = ({ productAccess, productsTypes, b2cUseNewDashboard, dbtShowNewMyDepositsPage, }) => {
    const localeCmsFormat = getLocale('en-IE').cmsFormat;
    const basePath = getDomainConfig(localeCmsFormat).basePath;
    const dashboardUrl = visitDashboard(b2cUseNewDashboard, true);
    const myInvestments = {
        id: 'myInvestments',
        title: 'My savings',
        href: '',
        subMenus: {
            layout: 'even',
            top: [
                {
                    id: 'dashboard-myInvestments',
                    type: 'basic',
                    title: 'My dashboard',
                    href: dashboardUrl,
                    icon: 'overviewIcon',
                    iconColor: '#0E6CC5',
                },
            ],
            main: [
                (productAccess.includes(HAS_FIXED_DEPOSIT_ACCOUNT) ||
                    productAccess.includes(HAS_FLEX_DEPOSIT_ACCOUNT)) && {
                    id: 'fixed-deposit',
                    type: 'basic',
                    title: 'Deposit accounts',
                    href: dbtShowNewMyDepositsPage
                        ? basePath + LINKS.DASHBOARD.DEPOSIT_PAGES.TERM
                        : getSavingglobalUrl('/#/MyInvestments/TermDeposit', localeCmsFormat),
                    icon: 'fixedDepositIcon',
                    iconColor: '#61AFD2',
                },
                productAccess.includes(HAS_OVERNIGHT_DEPOSIT_ACCOUNT) && {
                    id: 'overnight-deposit',
                    type: 'basic',
                    title: 'Demand deposit accounts',
                    href: dbtShowNewMyDepositsPage
                        ? basePath + LINKS.DASHBOARD.DEPOSIT_PAGES.OVERNIGHT
                        : getSavingglobalUrl('/#/MyInvestments/Overnight', localeCmsFormat),
                    icon: 'overnightMoneyIcon',
                    iconColor: '#9CD3E4',
                },
            ],
        },
    };
    const offers = {
        id: 'offers',
        title: 'Savings accounts',
        href: '',
        subMenus: {
            layout: 'even',
            main: [
                (productsTypes === null || productsTypes === void 0 ? void 0 : productsTypes.term_product_access) && {
                    id: 'fixedDeposit-offers',
                    type: 'advanced',
                    title: 'Deposit accounts',
                    href: `${basePath}/products/`,
                    description: 'Earn a fixed interest and withdraw your money at the end of the term',
                    icon: 'fixedDepositIcon',
                    iconColor: '#61AFD2',
                },
                (productsTypes === null || productsTypes === void 0 ? void 0 : productsTypes.overnight_product_access) && {
                    id: 'overnightDeposit-offers',
                    type: 'advanced',
                    title: 'Demand deposit accounts',
                    href: `${basePath}/products/overnight/`,
                    description: 'Earn a variable interest on your savings and access your money whenever you need',
                    icon: 'overnightMoneyIcon',
                    iconColor: '#9CD3E4',
                },
            ],
        },
    };
    const information = {
        id: 'information',
        title: 'Information',
        href: '',
        subMenus: {
            main: [
                {
                    id: 'e78780a1-cc15-45d9-95ca-53c52e905cc5',
                    type: 'advanced',
                    title: 'Deposit protection',
                    href: `${basePath}/deposit-guarantee/`,
                    description: 'Learn about the Deposit Guarantee Scheme',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt7ec22c5392125d5b/Deposit_protection.svg',
                    iconColor: '#0E6CC5',
                },
                {
                    id: '5d4de868-91cd-42cc-9358-08173ba5386f',
                    type: 'advanced',
                    title: 'Tax and revenue',
                    href: `${basePath}/tax/`,
                    description: 'How Raisin Bank savings accounts are taxed',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt9d8d32dc1f3a6166/Banks.svg',
                    iconColor: '#0E6CC5',
                },
                {
                    id: 'd63e6408-738b-4d6f-927a-bc2274804d69',
                    type: 'advanced',
                    title: 'Savings guides',
                    href: `${basePath}/savings/`,
                    description: 'Everything you need to know about savings',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt9878b0f3ba0d44ff/Savings_guides.svg',
                    iconColor: '#0E6CC5',
                },
                {
                    id: '1d4de43f-1134-12dd-123d-134d3aa52321d',
                    type: 'advanced',
                    title: 'Banking guides',
                    href: `${basePath}/banking/`,
                    description: 'Clear, practical guides to banking and finance',
                    icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt54dedccdfc38141b/Banking_guides.svg',
                    iconColor: '#0E6CC5',
                },
            ],
        },
    };
    const help = {
        id: '2e11a01f-4216-4fea-b05f-2fd46cf3a8b4',
        title: 'Help',
        href: '',
        subMenus: {
            main: [
                {
                    id: 'd41882ea-f390-47ed-b94e-3f7a7eea1a33',
                    type: 'text',
                    title: 'Contact us',
                    href: `${basePath}/contact/`,
                },
                {
                    id: 'f7c75a69-3287-483f-912f-d4c2432a0708',
                    type: 'text',
                    title: 'Press',
                    href: `${basePath}/press/`,
                },
                {
                    id: 'b16af5c5-2320-4317-80fa-fc2a375eb79c',
                    type: 'text',
                    title: 'FAQ',
                    href: 'https://contact.raisin.com/hc/en-gb/',
                },
            ],
        },
    };
    return [myInvestments, offers, information, help];
};
//# sourceMappingURL=irlMenus.js.map